<template>
  <div class="find-pas">
    <div v-show="model=='first'">
      <div class="top"></div>
      <input type="text" placeholder="请输入正确的手机号码/邮箱" v-model="phone">
      <div class="jtocode" v-show="jcshow"></div>
      <div class="wrongs" v-show="errorShow">{{errorMsg}}</div>
      <div class="login-btn" @click="sendMsg">下一步</div>
    </div>
    <div v-if="model=='second'">
      <div class="top1"></div>
      <p class="tel-msg">验证码已发送至您的手机：{{phone.substr(0,3) + '****' + phone.substr(7,4)}}</p>
      <input type="text" placeholder="请输入收到的验证码" v-model="code" />
      <div class="wrongs" v-show="errorShow">{{errorMsg}}</div>
      <div class="login-btn" @click="subcode">提交验证码</div>
      <p class="end-msg">未收到验证码？请<span class="red">{{sendNum}}</span>s后 <span class="blue" @click="resend">重新发送</span> 验证码或尝试 <span class="blue" @click="resendno">重新输入</span> 手机号码</p>
    </div>
    <div v-if="model=='third'">
      <div class="top1"></div>
      <div class="email-suc">
        <p class="end-msg center">确认邮件已发送至您的邮箱：{{phone}}</p>
        <p class="end-msg center">未收到验证码？请<span class="red">{{sendNum}}</span>s后 <span class="blue" @click="resend">重新发送</span> 验证码或尝试 <span class="blue" @click="resendno">重新输入</span> 邮箱</p>
      </div>
    </div>
    <div v-if="model=='four'">
      <div class="top2"></div>
      <input type="password" placeholder="请输入新密码" v-model="pass">
      <input type="password" placeholder="请再次输入新密码" v-model="repass">
      <div class="wrongs" v-show="errorShow">{{errorMsg}}</div>
      <div class="login-btn" @click="sure">确定</div>
    </div>
    <successalert :show="show" :msg="msg"></successalert>
  </div>

</template>

<script>
  import successalert from '../successalert/successalert.vue';
  import '../../js/geetest.js';
  import mixin from '../../js/public.js';

  export default{
      mixins: [mixin],
      components: {
        successalert
      },
      data () {
        return {
          model: 'first',
          errorShow: false,
          errorMsg: '',
          phone: '',
          id: '',
          jcshow: false,
          isphone: true,
          code: '',
          sendNum: 60,
          pass: '',
          repass: '',
          nu: '',
          show: false,
          msg: '恭喜你，密码修改成功！'
        };
      },
      created () {
        var _this = this;
        this.toCode();
        this.id = this.uuid();
        this.$http.post(_this.baseUrl + '/geetest/v3', {id: _this.id}, {credentials: true}).then(function (res) {
          if (res.body.type === 'success') {
            window.initGeetest({
              gt: res.body.data.gt,
              challenge: res.body.data.challenge,
              new_captcha: res.body.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.body.data.success
            }, _this.handlerPopup);
          } else {
            _this.errorMsg = '网络错误，请稍后再试';
            _this.errorShow = true;
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后再试';
          _this.errorShow = true;
        });
      },
      methods: {
        /* 确定修改密码 */
        sure () {
          var _this = this;
          var re = /^\d+$/;
          var re1 = /^[a-zA-Z]+$/;
          var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
          var val = this.pass;
          var len = val.length;
          if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
            this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
            this.errorShow = true;
            return;
          }
          this.errorShow = false;
          if (this.pass !== this.repass) {
            this.errorMsg = '两次输入的密码不一样，请重新输入';
            this.errorShow = true;
            return;
          }
          this.$http.post(_this.baseUrl + '/find/password/modify/1', {mobile: this.phone, code: this.code, password: this.pass}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              _this.show = true;
              window.location = '/sso-web/';
            } else {
              _this.errorMsg = '修改密码失败';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后再试';
            _this.errorShow = true;
          });
        },
        /* 重新输入 */
        resendno () {
          this.model = 'first';
          this.errorShow = false;
          this.phone = '';
        },
        /* 重新发送 */
        resend () {
          if (this.sendNum === 0) {
            this.model = 'first';
          }
        },
        /* 倒计时 */
        toCode () {
          var _this = this;
          var i = 60;
          this.sendNum = i;
          clearInterval(this.nu);
          this.nu = setInterval(function () {
            i--;
            _this.sendNum = i;
            if (i === 0) {
              clearInterval(_this.nu);
            }
          }, 1000);
        },
        /* 提交验证码 */
        subcode () {
           var _this = this;
          if (_this.code.length !== 6) {
            _this.errorShow = true;
            _this.errorMsg = '请输入正确的验证码';
          } else {
            _this.$http.post(_this.baseUrl + '/find/password/validate/1', {mobile: _this.phone, code: _this.code}, {credentials: true}).then(function (res) {
              if (res.body.type === 'success') {
                _this.model = 'four';
              } else {
                _this.errorShow = true;
                _this.errorMsg = '请输入正确的验证码';
              }
            }, function () {
              _this.errorShow = true;
              _this.errorMsg = '网络错误，请稍后重试';
            });
          }
        },
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            /* 判断用户是否存在 */
            _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.phone}, {credentials: true}).then(function (res) {
              if (res.body.type === 'success') {
                /* 如果存在，判断是手机号还是邮件 */
                if (res.body.data === true) {
                  _this.errorShow = false;
                  /* 如果是手机号，请求手机接口，否则请求邮箱接口 */
                  if (_this.isphone) {
                    _this.$http.post(_this.baseUrl + '/find/password/send/1', {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.phone}, {credentials: true}).then(function (res) {
                      _this.jcshow = false;
                      captchaObj.reset();
                      if (res.body.type === 'success') {
                        _this.model = 'second';
                        _this.toCode();
                      } else {
                        _this.errorShow = true;
                        _this.errorMsg = '操作错误，请稍后重试';
                      }
                    }, function () {
                      _this.errorMsg = '网络错误，请稍后重试';
                      _this.errorShow = true;
                    });
                  } else {
                    /* 请求邮箱接口 */
                    _this.$http.post(_this.baseUrl + '/find/password/send/2', {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, email: _this.phone, redirect_uri: window.location.href.replace(/findPas/, 'newPas')}, {credentials: true}).then(function (res) {
                      _this.jcshow = false;
                      captchaObj.reset();
                      if (res.body.type === 'success') {
                        _this.model = 'third';
                        _this.toCode();
                      } else if (res.body.code === 11140302) {
                        _this.errorShow = true;
                        _this.errorMsg = '邮箱不存在';
                      } else {
                        _this.errorShow = true;
                        _this.errorMsg = '操作错误';
                      }
                    }, function () {
                      _this.errorMsg = '网络错误，请稍后重试';
                      _this.errorShow = true;
                    });
                  }
                } else {
                  captchaObj.reset();
                  _this.errorShow = true;
                  _this.errorMsg = '账号不存在';
                }
              } else {
                captchaObj.reset();
                _this.errorShow = true;
                _this.errorMsg = '操作错误，请重试';
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            });
          });
        },
        sendMsg () {
          var phonetest = /^1[0-9]{10}$/;
          var emailtest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          if (phonetest.test(this.phone)) {
            this.jcshow = true;
            this.errorShow = false;
            this.isphone = true;
          } else if (emailtest.test(this.phone)) {
            this.jcshow = true;
            this.errorShow = false;
            this.isphone = false;
          } else {
            this.jcshow = false;
            this.errorMsg = '请输入正确的手机号码/邮箱';
            this.errorShow = true;
          }
        }
      }
  };
</script>

<style lang="scss" scoped="" type="text/css">
  @import "../../css/findPas.scss";
</style>



// WEBPACK FOOTER //
// findPas.vue?5a57b868